/**
 * @ngdoc Directive
 * @name vrm-nav
 * @example
 *
 * <vrm-nav></vrm-nav>
 */

import { localeEvents } from "@/angular/modules/vrm.locales";
import angular from "angular";
import VrmRemoteConsoleChoiceModal from "@/vue/components/modals/VrmRemoteConsoleChoiceModal.vue";
import { isBeta } from "@/utils/beta";
import BetaModal from "@/vue/components/modals/BetaModal";
import CKeditorModal from "@/vue/components/modals/CKeditorModal";
import axios from "axios";
import {
    REMOTE_CONSOLE_CLASSIC,
    REMOTE_CONSOLE_GUI_V2
} from "@/constants/installations";
const endpoint = axios.create({
    baseURL: window.location.origin
});

(function() {
    "use strict";

    angular.module("vrm.components").directive("vrmNav", vrmNav);

    /* @ngInject */
    function vrmNav(
        $state,
        $q,
        $rootScope,
        ApiService,
        VrmModalService,
        vrmConfig,
        locale,
        localStorageService,
        moment,
        MQTTRealtimeService,
        NotificationsService
    ) {
        return {
            scope: {
                installations: "=",
                activeInstallation: "=",
                user: "=",
                loading: "="
            },
            restrict: "E",
            template: require("@/angular/modules/vrm-components/nav/nav.template.html"),
            controller: controller,
            link: link
        };

        function getReleaseInfo() {
            const promise = $q.defer();
            endpoint
                .get(`/release.dev.json?cachebust=${new Date().getTime()}`, {
                    responseType: "json"
                })
                .then(response => {
                    return promise.resolve(response.data);
                })
                .catch(e => {
                    console.error("Couldn't get release info", e);
                    return promise.resolve(null);
                });
            return promise.promise;
        }

        function getCorrectTimeFormat(time) {
            // For deploy time as CET makes the date invalid
            if (time.includes("CET")) {
                time = time.replace(/(\d{2}:\d{2}:\d{2}) CET (\d{4})/, "$2-$1");
            }
            const date = new Date(time);

            var year = date.getFullYear();
            var month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
            var day = date
                .getDate()
                .toString()
                .padStart(2, "0");
            var hours = date
                .getHours()
                .toString()
                .padStart(2, "0");
            var minutes = date
                .getMinutes()
                .toString()
                .padStart(2, "0");

            return `${year}-${month}-${day} ${hours}:${minutes} CET`;
        }

        /**
         * Link
         * @param $scope
         */
        function link($scope) {
            $scope.$state = $state;
            $scope.searchInstallation = "";

            $scope.mqttEnabled = vrmConfig.enableMQTT;

            $scope.searchingForPortalId = false;

            $scope.shouldShowNotificationsMenuItem = function() {
                return true;
                // return NotificationsService.checkMobileWrapper();
            };

            $scope.$watch("searchInstallation", function(search) {
                if (
                    _.isString(search) &&
                    search.length >= 12 &&
                    $rootScope.userState.isAdmin
                ) {
                    $scope.searchingForPortalId = true;
                    $scope.openMenu("installations");
                    // Might be VRM portal id, search for it
                    ApiService.admin("installations", {
                        "filter[identifier]": search
                    }).then(function(response) {
                        $scope.searchingForPortalId = false;
                        // Check if no record is found
                        if (response.data.num_records < 1) return;

                        _.each(response.data.records, function(record) {
                            if (
                                record.identifier.toLowerCase() ==
                                search.toLowerCase()
                            ) {
                                //Installation found, go to it
                                $state.go("base.installation.dashboard", {
                                    id: record.idSite
                                });
                                $scope.searchInstallation = "";
                            }
                        });
                    });
                } else if (_.isString(search) && search.length >= 1) {
                    $scope.openMenu("installations");
                }
            });

            $scope.goToResultsOnEnter = function($event) {
                var keyCode = $event.which || $event.keyCode;
                // On pressing enter go to the installation overview to show the results.
                if (keyCode === 13) {
                    $state.go("base.installation-overview", {
                        search: $scope.searchInstallation
                    });
                }
            };

            // Maps object loaded
            $scope.openWysiwygModal = function(installation) {
                VrmModalService.openVueModal(CKeditorModal, {
                    installationName: installation.name,
                    installationId: installation.id,
                    content: installation.notes,
                    installation: installation
                });
            };
            $scope.openShareModal = function(installation) {
                VrmModalService.openShareModal($scope, installation);
            };
            $scope.openCarouselModal = function(installation) {
                VrmModalService.openCarouselModal($scope, installation);
            };

            $scope.openRemoteConsoleModal = function(installation) {
                const hasOldGui =
                    installation.view_permissions.rc_classic &&
                    installation.GUIv !== 2;
                const hasNewGui = installation.view_permissions.rc_gui_v2;
                const existingChoice = installation.remoteConsoleChoice;

                if (hasOldGui && hasNewGui && !existingChoice) {
                    $scope.openRemoteConsoleChoiceModal(installation);
                } else if (
                    hasNewGui &&
                    existingChoice === REMOTE_CONSOLE_GUI_V2
                ) {
                    $scope.onGui2Open(installation);
                } else if (
                    hasOldGui &&
                    existingChoice === REMOTE_CONSOLE_CLASSIC
                ) {
                    $scope.openClassicRemoteConsole(installation);
                } else if (hasNewGui && !existingChoice) {
                    $scope.onGui2Open(installation);
                } else if (hasOldGui && !existingChoice) {
                    $scope.openClassicRemoteConsole(installation);
                } else {
                    // The existingChoice is not valid (anymore) for this site, because the GUIv (running version) was
                    // changed on the device and the choice did not get updated with it. Reset choice and open v2, or v1.
                    $scope.saveRemoteConsolePreference(installation, null);
                    if (hasNewGui) {
                        $scope.onGui2Open(installation);
                    } else if (hasOldGui) {
                        $scope.openClassicRemoteConsole(installation);
                    } else {
                        // Remote console button should not have been visible in sidebar, v1 and v2 both not available.
                        console.error(
                            "Could not open remote console, V1 and V2 are not available."
                        );
                    }
                }
            };

            $scope.saveRemoteConsolePreference = async (
                installation,
                choice = REMOTE_CONSOLE_GUI_V2
            ) => {
                try {
                    const response = await ApiService.setRemoteConsolePreference(
                        installation.idSite,
                        choice
                    );

                    if (!response || !response.data || !response.data.success) {
                        console.warn(
                            "Could not save remote console preference."
                        );
                        return;
                    }

                    $rootScope.$broadcast("rc-changed", this.selected);
                } catch (e) {
                    console.warn(
                        "Could not save remote console preference.",
                        e
                    );
                }
            };

            $scope.openClassicRemoteConsole = installation => {
                if ($scope.mqttGuiSubscription) {
                    MQTTRealtimeService.unsubScribeFromPath(
                        $scope.mqttGuiSubscription
                    );
                    $scope.mqttGuiSubscription = null;
                }

                $scope.mqttGuiSubscription = {
                    identifier: installation.identifier,
                    dbusServiceType: "platform",
                    dbusPath: "/Gui/RunningVersion",
                    instance: "0",
                    callbackIdentifier: `running_classic_gui_${installation.identifier}`,
                    callback: message => {
                        // Skip message if payload value is null
                        if (message.payload.value === null) return;

                        const GUIv = MQTTRealtimeService.convertValue(
                            "GUIv",
                            message.payload.value
                        );
                        console.warn("RC RunningVersion:", GUIv, "RC_CLASSIC");

                        if (GUIv === 2) {
                            $scope.lastMqttGuiValue = GUIv;
                            $scope.currentInstallation.GUIv = 2;
                            $scope.currentInstallation.remoteConsoleChoice = REMOTE_CONSOLE_GUI_V2;

                            if ($scope.remoteConsoleClassicOpened) {
                                $scope.lastMqttGuiValue = null;

                                VrmModalService.closeActiveModal();

                                MQTTRealtimeService.unsubScribeFromPath(
                                    $scope.mqttGuiSubscription
                                );
                                $scope.mqttGuiSubscription = null;

                                $scope.saveRemoteConsolePreference(
                                    installation,
                                    null
                                );
                                $scope.onGui2Open(installation);
                            }
                        }
                    }
                };

                MQTTRealtimeService.subscribeToPath($scope.mqttGuiSubscription);

                VrmModalService.openRemoteConsoleModal($scope, installation, {
                    onClose: () => {
                        MQTTRealtimeService.unsubScribeFromPath(
                            $scope.mqttGuiSubscription
                        );
                        $scope.mqttGuiSubscription = null;
                        $scope.lastMqttGuiValue = null;
                        $scope.remoteConsoleClassicOpened = false;
                    },
                    onOpened: () => {
                        $scope.remoteConsoleClassicOpened = true;
                    }
                });
            };

            $scope.openRemoteConsoleChoiceModal = installation => {
                VrmModalService.openVueModal(VrmRemoteConsoleChoiceModal, {
                    idSite: installation.idSite,
                    onSelected: value => {
                        VrmModalService.closeActiveModal();

                        if (value === REMOTE_CONSOLE_GUI_V2) {
                            $scope.onGui2Open(installation);
                        } else {
                            $scope.openClassicRemoteConsole(installation);
                        }
                    }
                });
            };

            // New function for full-screen remote console choice
            $scope.openRemoteConsoleChoiceFullScreen = function(installation) {
                const hasOldGui =
                    installation.view_permissions.rc_classic &&
                    installation.GUIv !== 2;
                const hasNewGui = installation.view_permissions.rc_gui_v2;
                const existingChoice = installation.remoteConsoleChoice;

                if (hasOldGui && hasNewGui && !existingChoice) {
                    // Navigate to full-screen choice view
                    $state.go("remote-console-choice", {
                        id: installation.idSite
                    });
                } else if (
                    hasNewGui &&
                    existingChoice === REMOTE_CONSOLE_GUI_V2
                ) {
                    // Navigate directly to full-screen V2 console
                    $state.go("remote-console-2", { id: installation.idSite });
                } else if (
                    hasOldGui &&
                    existingChoice === REMOTE_CONSOLE_CLASSIC
                ) {
                    $scope.openClassicRemoteConsole(installation);
                } else if (hasNewGui && !existingChoice) {
                    $state.go("remote-console-2", { id: installation.idSite });
                } else if (hasOldGui && !existingChoice) {
                    $scope.openClassicRemoteConsole(installation);
                } else {
                    // Reset choice and determine which console to open
                    $scope.saveRemoteConsolePreference(installation, null);
                    if (hasNewGui) {
                        $state.go("remote-console-2", {
                            id: installation.idSite
                        });
                    } else if (hasOldGui) {
                        $scope.openClassicRemoteConsole(installation);
                    } else {
                        console.error(
                            "Could not open remote console, V1 and V2 are not available."
                        );
                    }
                }
            };

            // Check for url query params to open the modal
            const urlParams = new URLSearchParams(window.location.search);
            const openModal = urlParams.get("openModal");
            if (openModal) {
                setTimeout(() => {
                    switch (openModal) {
                        case "vnc":
                            $scope.openRemoteConsoleModal(
                                $scope.activeInstallation
                            );
                            break;
                        case "share":
                            $scope.openShareModal($scope.activeInstallation);
                            break;
                        case "photos":
                            $scope.openCarouselModal($scope.activeInstallation);
                            break;
                        case "notes":
                            $scope.openWysiwygModal($scope.activeInstallation);
                            break;
                        case "upload-ccgx":
                            $scope.openCCGXUploadModal();
                            break;
                        default:
                            console.error("Unknown modal type", openModal);
                            break;
                    }
                }, 500);
            }
        }

        /* @ngInject */
        function controller(
            $timeout,
            $scope,
            $rootScope,
            $state,
            $window,
            $transitions,
            $location,
            vrmNavToggleEvent,
            VrmModalService,
            VrmLangService,
            VrmNavService,
            InstallationsService,
            locale,
            vrmNotificationType,
            vrmNotificationsService,
            localStorageService,
            AppearanceService,
            vrmConfig
        ) {
            $scope.gui2ModalOpen = false;
            $scope.isMenuToggledOpen = false;

            $scope.onGui2Open = function(installation) {
                $scope.gui2ModalOpen = true;

                if ($scope.mqttGuiSubscription) {
                    MQTTRealtimeService.unsubScribeFromPath(
                        $scope.mqttGuiSubscription
                    );
                    $scope.mqttGuiSubscription = null;
                }

                $scope.mqttGuiSubscription = {
                    identifier: installation.identifier,
                    dbusServiceType: "platform",
                    dbusPath: "/Gui/RunningVersion",
                    instance: "0",
                    callbackIdentifier: `running_new_gui_${installation.identifier}`,
                    callback: message => {
                        // Skip message if payload value is null
                        if (message.payload.value === null) return;

                        const GUIv = MQTTRealtimeService.convertValue(
                            "GUIv",
                            message.payload.value
                        );
                        console.warn("RC RunningVersion:", GUIv, "RC_GUI_V2");

                        if (!$scope.lastMqttGuiValue) {
                            $scope.lastMqttGuiValue = GUIv;
                        }

                        if (GUIv === 2 && GUIv !== $scope.lastMqttGuiValue) {
                            $scope.currentInstallation.GUIv = 2;
                            $scope.currentInstallation.remoteConsoleChoice = null;
                            $scope.lastMqttGuiValue = GUIv;

                            $scope.saveRemoteConsolePreference(
                                installation,
                                null
                            );
                        } else if (
                            GUIv === 1 &&
                            GUIv !== $scope.lastMqttGuiValue
                        ) {
                            $scope.currentInstallation.GUIv = 1;
                            $scope.currentInstallation.remoteConsoleChoice = null;
                            $scope.lastMqttGuiValue = GUIv;

                            if ($scope.gui2ModalOpen) {
                                $scope.saveRemoteConsolePreference(
                                    installation,
                                    null
                                );
                            }
                        }
                    }
                };

                MQTTRealtimeService.subscribeToPath($scope.mqttGuiSubscription);
            };
            $scope.onGui2Close = function() {
                if ($scope.mqttGuiSubscription) {
                    MQTTRealtimeService.unsubScribeFromPath(
                        $scope.mqttGuiSubscription
                    );
                    $scope.mqttGuiSubscription = null;
                }

                $scope.gui2ModalOpen = false;
                document.body.style.overflow = "auto";
            };

            $scope.releaseInfo = null;
            getReleaseInfo().then(response => {
                if (response) {
                    $scope.releaseInfo = response;
                    switch ($scope.releaseInfo.env) {
                        case "beta":
                            $scope.releaseInfo.env = "Beta";
                            break;
                        case "acceptance":
                            $scope.releaseInfo.env = "Acceptance";
                            break;
                        case "master":
                            $scope.releaseInfo.env = "Production";
                            break;
                        default:
                            $scope.releaseInfo.env = "Local";
                    }
                    $scope.isRestrictedAdmin =
                        $rootScope.userState.isRestrictedAdmin;
                    $scope.isAdmin = $rootScope.userState.isAdmin;

                    $scope.releaseInfo.lastCommitTime = getCorrectTimeFormat(
                        $scope.releaseInfo.lastCommitTime
                    );
                    $scope.releaseInfo.lastDeployTime = getCorrectTimeFormat(
                        $scope.releaseInfo.lastDeployTime
                    );
                }
            });

            $scope.isImpersonatedUser = localStorageService.get("adminToken");

            $scope.direction = "left";
            $scope.dontCloseMenu = false;
            $scope.openMenu = async function(
                menu,
                installation,
                direction,
                dontCloseMenu,
                restoreScroll
            ) {
                if ($scope.isMenuToggledOpen) {
                    // Reapply background blur because it gets reset on state change when navigating between sites
                    $(".vrm-nav__overlay").css("display", "block");
                }

                var needsRedraw = false;

                // demoShare: remove the demoShare param from the url when going to the root or installations menu
                if (
                    "demoShare" in $location.search() &&
                    menu === "installations"
                ) {
                    if (localStorageService.get("token")) {
                        window.location.href = $state.href(
                            "base.installation-overview"
                        );
                    } else {
                        ApiService.call(
                            "/auth/loginAsDemo",
                            null,
                            "POST",
                            true
                        ).then(function(response) {
                            localStorageService.set(
                                "token",
                                response.data.token
                            );
                            window.location.href = $state.href(
                                "base.installation-overview"
                            );
                        });
                    }
                }
                const siteId =
                    installation && installation.idSite
                        ? installation.idSite
                        : null;
                if (
                    installation != undefined &&
                    installation &&
                    installation.view_permissions
                ) {
                    if (
                        !$scope.currentInstallation ||
                        installation.idSite != $scope.currentInstallation.idSite
                    )
                        needsRedraw = true;
                    $scope.currentInstallation = installation;
                } else if (siteId) {
                    const installation = await InstallationsService.getInstallation(
                        siteId
                    );
                    $scope.currentInstallation = installation;
                }

                $scope.dontCloseMenu =
                    typeof dontCloseMenu != "undefined" && dontCloseMenu;
                if (restoreScroll) {
                    $timeout(function() {
                        const scrollPos = parseInt(
                            sessionStorage.getItem("scrollPosition")
                        );
                        window.scrollTo(0, scrollPos);
                    });
                }
                needsRedraw = needsRedraw || $scope.currentMenu != menu;
                if (needsRedraw) {
                    // Animation direction
                    $scope.direction =
                        typeof direction != "undefined" && direction == "right"
                            ? "right"
                            : "left";
                    $scope.currentMenu = menu;

                    const $nav = $(".vrm-nav");
                    if ($nav.length) {
                        $nav.scrollTop(0);
                    }
                }
            };

            $scope.isBeta = isBeta();

            $scope.isGroupsLinkActive = () => {
                return /base\.(user|installation)-groups?/.test(
                    $state.current.name
                );
            };

            $scope.isEasterModeEnabled = AppearanceService.isEasterThemeActive();

            $scope.whatsnew_changelog = {
                active: false,
                logs: [],
                groupedLogs: {},
                isChecked: true
            };

            ApiService.call(`/whatsnew-changelog`, null, "GET").then(function(
                response
            ) {
                $scope.whatsnew_changelog.logs = response.data.records;
                const changelogDatePromise = VrmNavService.getLatestCheckedChangelogDate();
                const whatsnewDatePromise = VrmNavService.getLastCheckedWhatsnewDate();
                Promise.all([changelogDatePromise, whatsnewDatePromise]).then(
                    function(values) {
                        const lastViewedChangelogDate = values[0];
                        const lastClickedWhatsnewDate = values[1];

                        $scope.whatsnew_changelog.isChecked = true;

                        _.each($scope.whatsnew_changelog.logs, function(log) {
                            log.isNew =
                                log.createdAt * 1000 >
                                    lastViewedChangelogDate ||
                                log.updatedAt * 1000 > lastClickedWhatsnewDate;

                            if (
                                log.updatedAt * 1000 >
                                lastClickedWhatsnewDate
                            ) {
                                $scope.whatsnew_changelog.isChecked = false;
                            }

                            if (
                                !$scope.whatsnew_changelog.groupedLogs[
                                    log.createdAt
                                ]
                            ) {
                                $scope.whatsnew_changelog.groupedLogs[
                                    log.createdAt
                                ] = [];
                            }
                            $scope.whatsnew_changelog.groupedLogs[
                                log.createdAt
                            ].push(log);
                        });

                        // group logs based on date
                        $scope.whatsnew_changelog.groupedLogs = _.chain(
                            $scope.whatsnew_changelog.logs
                        )
                            .groupBy(function(log) {
                                return moment(log.createdAt * 1000)
                                    .hours(23)
                                    .minutes(59)
                                    .seconds(59)
                                    .milliseconds(0);
                            })
                            .map(function(logs, createdAt) {
                                return {
                                    createdAt:
                                        moment(createdAt).valueOf() / 1000,
                                    logs: logs
                                };
                            })
                            .value();
                    }
                );
            });

            const selectedWhatsnewListener = $rootScope.$on(
                "viewSelectedWhatsnewChangelog",
                function(event, viewedLog) {
                    VrmNavService.getLatestCheckedChangelogDate().then(function(
                        lastViewedChangelogDate
                    ) {
                        if (
                            lastViewedChangelogDate >
                            viewedLog.createdAt * 1000
                        ) {
                            $scope.whatsnew_changelog.logs.find(
                                log => log.id === viewedLog.id
                            ).isNew = false;
                            return;
                        }
                        _.each($scope.whatsnew_changelog.logs, function(log) {
                            log.isNew = log.createdAt > viewedLog.createdAt;
                        });
                        VrmNavService.setLatestCheckedChangelogDate(
                            viewedLog.createdAt * 1000
                        );
                    });
                }
            );

            $scope.onWhatsnewChangelogClick = function() {
                if (!$scope.whatsnew_changelog.active) {
                    $scope.whatsnew_changelog.isChecked = true;
                    VrmNavService.setLastCheckedWhatsnewDate(new Date() * 1);
                }
                $scope.whatsnew_changelog.active = !$scope.whatsnew_changelog
                    .active;

                if (window.innerWidth < 750)
                    $("html")[0].style.overflow = "hidden";
            };

            $scope.onOutsideWhatsnewChangelogClick = function() {
                if ($scope.whatsnew_changelog.active) {
                    closeWhatsnewChangelogPopup();
                    $scope.$applyAsync();
                    $rootScope.$broadcast("onOutsideWhatsnewChangelogClick");
                    return true;
                }

                return false;
            };

            function closeWhatsnewChangelogPopup() {
                $scope.whatsnew_changelog.active = false;
                if (window.innerWidth < 750)
                    $("html")[0].style.overflow = "scroll";
            }

            const closeChangelogPopupListener = $rootScope.$on(
                "closeChangelogPopupEvent",
                function(event, data) {
                    closeWhatsnewChangelogPopup();
                }
            );

            function setState(toState, toParams) {
                const groupStates = [
                    "base.user-groups",
                    "base.user-group",
                    "base.installation-groups",
                    "base.installation-group"
                ];

                // demoShare: keep the ?demoShare URL param between menu navigation's
                if ("demoShare" in $location.search()) {
                    $transitions.onStart({}, trans => {
                        trans.promise.finally(() => {
                            $timeout(() => {
                                $location.search({ demoShare: true });
                            });
                        });
                    });
                }

                if (toState.name.indexOf("base.installation.") === 0) {
                    InstallationsService.getInstallation(toParams.id).then(
                        function(installation) {
                            $scope.currentInstallation = installation;

                            // Check if the url contains ?openRemoteConsole, open the remote and remove the param
                            if ("openRemoteConsole" in $location.search()) {
                                // add a timeout to allow the remote console modal to open
                                $timeout(() => {
                                    $scope.openRemoteConsoleModal(installation);
                                }, 2000);

                                $timeout(() => {
                                    $location.search({
                                        ...$location.search(),
                                        openRemoteConsole: null
                                    });
                                });
                            }

                            $scope.openMenu(
                                toState.name.indexOf(
                                    "base.installation.settings."
                                ) === 0
                                    ? "settings"
                                    : toState.name.indexOf(
                                          "base.installation.reporting"
                                      ) === 0
                                    ? "reporting"
                                    : "installation"
                            );
                        }
                    );
                } else if (toState.name.indexOf("base.profile.") === 0) {
                    $scope.openMenu("root");
                } else if (toState.name.indexOf("base.admin.") === 0) {
                    $scope.openMenu("admin");
                } else if (groupStates.includes(toState.name)) {
                    $scope.openMenu("groups");
                } else if (
                    toState.name.indexOf("base.installation-overview") === 0
                ) {
                    $scope.openMenu("installations");
                } else if (
                    toState.name.indexOf("base.manage-access-tokens") === 0
                ) {
                    $scope.openMenu("integrations");
                } else if (
                    toState.name.indexOf("base.firmware-overview") === 0 ||
                    toState.name.indexOf("base.release-overview") === 0 ||
                    toState.name.indexOf("base.create-new-release") === 0
                ) {
                    $scope.openMenu("firmware-library");
                }
            }

            $scope.openMenu("root");

            var closeMenu;
            // Force close menu (used by dashboard link)
            $scope.closeMenu = function() {
                if (typeof closeMenu === "function") closeMenu();
            };

            $(function() {
                setState($state.current, $state.params);
                var $body = $("body"),
                    $nav = $(".vrm-nav"),
                    $overlay = $(".vrm-nav__overlay"),
                    navToggled = false,
                    navToggleAnimationSpeed = 200;

                //Close menu on link load
                var rootScopeOnStateChange = $rootScope.$on(
                    "$stateChangeSuccess",
                    function(event, toState, toParams) {
                        setState(toState, toParams);
                        if (navToggled && !$scope.dontCloseMenu) {
                            closeMenu();
                        }
                        $scope.dontCloseMenu = false;
                    }
                );

                // Small helper function for a cross browser transition end
                function transitionEnd(element, callback) {
                    var done = false;
                    var finish = function() {
                        if (done) return;
                        callback();
                        done = true;
                    };
                    element.one("transitionend", finish);
                    // This is a fallback for old IE versions, without transition end support
                    // animation duration = 0.2s, so kick in right after that
                    setTimeout(finish, 201);
                }

                var rootScopeOnToggle = $rootScope.$on(
                    vrmNavToggleEvent.toggle,
                    function() {
                        if (!navToggled) {
                            $nav.show(0, function() {
                                transitionEnd($nav, function() {
                                    $nav.removeClass(
                                        "vrm--transitioning-in"
                                    ).addClass("vrm--active");
                                    $timeout(() => {
                                        $scope.isMenuToggledOpen = true;
                                    });
                                });
                                $nav.addClass("vrm--transitioning-in");
                            });

                            $overlay.fadeIn(navToggleAnimationSpeed);
                            navToggled = true;
                            $overlay.on("click", closeMenu);
                        } else {
                            closeMenu();
                        }
                    }
                );

                $scope.$on("$destroy", function() {
                    selectedWhatsnewListener();
                    closeChangelogPopupListener();
                    rootScopeOnStateChange();
                    rootScopeOnToggle();
                });

                closeMenu = function() {
                    $timeout(() => {
                        $scope.isMenuToggledOpen = false;
                    });

                    $overlay.fadeOut(navToggleAnimationSpeed, function() {
                        $overlay.off("click").hide();
                    });

                    $nav.removeClass("vrm--active").addClass(
                        "vrm--transitioning-out"
                    );
                    transitionEnd($nav, function() {
                        $nav.removeClass("vrm--transitioning-out").css(
                            "display",
                            ""
                        );
                    });

                    navToggled = false;
                };

                if (
                    VrmNavService.model.forceOpenMenu &&
                    $(".vrm-nav__handle").is(":visible")
                ) {
                    $rootScope.$emit(vrmNavToggleEvent.toggle);
                    VrmNavService.setForceOpenMenu(false);
                }
            });

            $scope.openLeaveBetaModal = () => {
                VrmModalService.openVueModal(BetaModal, {
                    switchToBeta: false
                });
            };

            //Open installations in nav bar during scroll position restore
            window.addEventListener("popstate", () => {
                if ($state.includes("base.installation-overview")) {
                    $scope.openMenu(
                        "installations",
                        false,
                        "right",
                        false,
                        true
                    );
                }
            });

            $scope.openLanguageModal = VrmModalService.openLanguageModal;
            VrmLangService.getLang().then(function(lang) {
                $scope.lang = lang;
            });
            $scope.$on(localeEvents.localeChanges, function(event, lang) {
                $scope.lang = lang;
            });

            var errorNotification = null;
            $scope.openCCGXUploadModal = function() {
                VrmModalService.openUploadModal($scope, "ccgx", function(
                    files
                ) {
                    locale.ready("dashboard").then(function() {
                        if (!files && files.length !== 1) return;
                        var file = files[0];

                        // Check the file size before sending it to prevent entity too large (413) from ngnix.
                        if (file.size > 200 * Math.pow(10, 6)) {
                            vrmNotificationsService.add(
                                {
                                    type: vrmNotificationType.ERROR,
                                    message: locale.getString(
                                        "dashboard.ccgx_file_too_big"
                                    )
                                },
                                true
                            );
                            return;
                        }

                        var uploadingNotification = vrmNotificationsService.add(
                            {
                                type: vrmNotificationType.INFO,
                                timeout: 5 * 60 * 1000,
                                message: locale.getString(
                                    "dashboard.ccgx_uploading"
                                )
                            }
                        );

                        var data = new FormData();

                        data.append("data", file);

                        function processResponse(response) {
                            var messageTimeout = 60 * 1000;
                            vrmNotificationsService.remove(
                                uploadingNotification
                            );
                            if (errorNotification) {
                                vrmNotificationsService.remove(
                                    errorNotification
                                );
                            }
                            if (
                                response &&
                                response.data &&
                                response.data.success
                            ) {
                                vrmNotificationsService.add({
                                    type: vrmNotificationType.SUCCESS,
                                    timeout: messageTimeout,
                                    message: locale.getString(
                                        "dashboard.ccgx_uploaded",
                                        { count: response.data.num_processed }
                                    )
                                });
                            } else if (
                                response &&
                                response.data &&
                                response.data.errors
                            ) {
                                locale.ready("core").then(function() {
                                    vrmNotificationsService.add({
                                        type: vrmNotificationType.ERROR,
                                        message: ApiService.formatErrors(
                                            response
                                        ),
                                        timeout: messageTimeout
                                    });
                                });
                            } else {
                                vrmNotificationsService.add({
                                    type: vrmNotificationType.ERROR,
                                    message: locale.getString(
                                        "dashboard.ccgx_upload_error"
                                    ),
                                    timeout: messageTimeout
                                });
                            }
                        }

                        ApiService.call2("/installations/data-upload", data, {
                            method: "POST",
                            skipAuthorization: false,
                            responseType: "json",
                            skipResultChecks: true,
                            throwOnError: true
                        })
                            .then(processResponse)
                            .catch(processResponse);
                    });
                });
            };

            // Listen for rc-changed event on the rootscope. Indicated that the remote console UI setting has changed
            // and we need to refresh the current installation.
            $rootScope.$on("rc-changed", (e, option) => {
                if ($scope.currentInstallation) {
                    $scope.currentInstallation.remoteConsoleChoice = option;
                }
            });

            $rootScope.$emit("checkMapsAvailabilityEvent");

            $scope.showTeamsAndGroups = () => {
                if (
                    $scope.$root &&
                    $scope.$root.userState &&
                    $scope.$root.userState.isDemo
                ) {
                    return false;
                }
                if (
                    $scope.$root &&
                    $scope.$root.userState &&
                    $scope.$root.userState.isShare
                ) {
                    return false;
                }
                if (
                    $scope.$root &&
                    $scope.$root.user &&
                    $scope.$root.user.isPartOfGroups
                ) {
                    return true;
                }
                if ($scope.installations.length > 1) {
                    return true;
                }
                return false;
            };
        }
    }
})();
